import { Component, inject, Inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormBuilder, FormControl, Validators, AbstractControl, UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle, MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgbDateStruct, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepicker, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { injectStripe, StripeElementsDirective, StripePaymentElementComponent, NgxStripeModule } from 'ngx-stripe';
import { PaymentMethod, StripeElementsOptions, StripePaymentElementOptions, StripePaymentElement } from '@stripe/stripe-js';
import { forkJoin, firstValueFrom } from 'rxjs';
import { getUrl } from 'aws-amplify/storage';
import { environment } from "../../../../environments/environment";
import { ProductRatingsComponent } from '../../common/product-ratings/product-ratings.component';
import { BookingDialogComponent } from './booking-dialog/booking-dialog.component';
import { BookingConfirmationDialogComponent, BookingConfirmationData } from './booking-confirmation-dialog/booking-confirmation-dialog.component';
import { ServiceService } from '../../../services/service.service';
import { StripeService } from '../../../services/stripe.service';
import { EmailService } from '../../../services/email.service';
import { Booking } from '../../../models/booking.interface';

export interface DialogData {
  activity : any;
}

export interface ImageCarouselDialogData {
  pictures: any[];
  initialIndex: number;
  activityName: string;
}
export interface TimeSlotsI {
  timeSlot: string;
  personSlots: number;
}
export interface AvailabilityI {
  availabilityDate: string;
  timeSlots: TimeSlotsI[];
}
@Component({
    selector: 'app-activity-booking-page',
    templateUrl: './activity-booking-page.component.html',
    styleUrls: ['./activity-booking-page.component.scss'],
    standalone: true,
    imports: [
      CommonModule, 
      RouterModule, 
      ReactiveFormsModule, 
      MatDialogModule, 
      NgbDatepickerModule, 
      MatSnackBarModule, 
      NgxStripeModule,
      MatIconModule,
      MatCardModule,
      MatListModule,
      MatTooltipModule,
      MatChipsModule,
      MatFormFieldModule,
      MatInputModule,
      MatButtonModule,
      MatDatepickerModule,
      MatNativeDateModule,
      NgbModule,
      ProductRatingsComponent
    ]
})
export class ActivityBookingPageComponent implements OnInit {

  activityId!: string;
  activity!: any;

  defaultActivityValues: any = {
    __typename: "Activity",
    id: "",
    name: "",
    topPick: false,
    mainActivityType: "",
    description: "",
    fullDescription: "",
    duration: "",
    ameniyTags: "",
    bookingTag: null,
    bookingTagActive: false,
    sellOut: false,
    searchTags: "",
    rating:  null,
    reviews:  null,
    pricePerPerson:  null,
    discountedPrice:  null,
    currencyType: "",
    highlights: "",
    notSuitable: "",
    mapPoint: null,
    importantInfo: null,
    Pictures: {
      __typename: "ModelPictureConnection",
      items: [
        {
          __typename: "Picture",
          id: "",
          url: "",
          description: "",
          activityID: "",
          createdAt: "",
          updatedAt: ""
        },
        {
          __typename: "Picture",
          id: "",
          url: "",
          description: "",
          activityID: "",
          createdAt: "",
          updatedAt: ""
        },
        {
          __typename: "Picture",
          id: "",
          url: "",
          description: "",
          activityID: "",
          createdAt: "",
          updatedAt: ""
        },
        {
          __typename: "Picture",
          id: "",
          url: "",
          description: "",
          activityID: "",
          createdAt: "",
          updatedAt: ""
        }
      ]
    },
    MeetingPoint: null,
    ImportantInformations: null,
    Amenities: null,
    Includes: null,
    storeID: "",
    language: "",
    Availabilities: null,
    startDate: "",
    endDate: "",
    createdAt: "",
    updatedAt: "",
    activityMeetingPointId: "",
  };
  


  reviews!: string;
  pictures: any[] = [];
  hasValidPictures: boolean = false;
  storeName!: string;
  userId: string = "";
  selected: Date | null;
  timeSlotsPrefix: string = "timeSlots";
  timeSelected: boolean = false;
  slotsDisabled: boolean = true;
  env = environment.environmentName;

  @ViewChild(StripeElementsDirective) elements!: StripeElementsDirective;

  @ViewChild(StripePaymentElementComponent)
  paymentElement!: StripePaymentElementComponent;

  private readonly fb = inject(UntypedFormBuilder);

  // Stripe publishable key from environment
  stripe = injectStripe(environment.stripePublishableKey);
  paying = signal(false);

  paymentElementForm = this.formBuilder.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone: [''],
    address: [''],
    zipcode: [''],
    city: [''],
    referralCode: [''],
    hotelName: [''],
    hotelRoomNumber: [''],
    amount: [2500, [Validators.required, Validators.pattern(/\d+/)]]
  });

  elementsOptions: StripeElementsOptions = {
    locale: 'en',
    appearance: {
      theme: 'stripe',
      labels: 'floating',
      variables: {
        colorPrimary: '#673ab7',
      }
    }
  } as StripeElementsOptions;

  paymentElementOptions: StripePaymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
      radios: false,
      spacedAccordionItems: false
    },
    fields: {
      billingDetails: {
        address: {
          country: 'auto',
        },
      },
    }
  };
  paymentMethod: PaymentMethod | string;

  sPayementElement : StripePaymentElement;
  getElement() {
    this.sPayementElement = this.elements._elements.getElement('payment');
    console.log("sPaymentElement", this.sPayementElement);
  }

  /**
   * Normalizes currency type to ISO 4217 code format (lowercase)
   * Converts currency names like "US Dollar" or "USD" to "usd"
   */
  private normalizeCurrency(currencyType: string | undefined | null): string {
    if (!currencyType) {
      return 'usd';
    }

    const normalized = currencyType.trim().toLowerCase();

    // Map common currency names to ISO codes
    const currencyMap: { [key: string]: string } = {
      'us dollar': 'usd',
      'usd': 'usd',
      'euro': 'eur',
      'eur': 'eur',
      'ang': 'ang',
      'netherlands antillean guilder': 'ang',
      'euro dollar': 'eur',
      'eurodollar': 'eur',
    };

    // Check if it's a known currency name
    if (currencyMap[normalized]) {
      return currencyMap[normalized];
    }

    // If it's already a 3-letter code, return it as lowercase
    if (normalized.length === 3 && /^[a-z]{3}$/.test(normalized)) {
      return normalized;
    }

    // Default fallback
    console.warn(`[CURRENCY] Unknown currency type "${currencyType}", defaulting to "usd"`);
    return 'usd';
  }

  showPaymentInfo() {
    if (!this.dateSelected || !this.availabilityI || this.totalCurrentCost <= 0) {
      this.openSnackBar('Please select a date and time slots before proceeding to payment', 'Close');
      return;
    }

    this.timeToPay = true;

    // Create payment intent
    const amountInCents = Math.round(this.totalCurrentCost * 100); // Convert to cents
    
    // Normalize currency to ISO 4217 code format
    const normalizedCurrency = this.normalizeCurrency(this.activity.currencyType);
    
    // Prepare payment intent parameters
    const paymentIntentData = {
      amount: amountInCents,
      currency: normalizedCurrency,
      activityId: this.activity.id,
      metadata: {
        activityName: this.activity.name,
        activityId: this.activity.id,
        date: this.dateSelected ? this.dateSelected.toISOString() : '',
        totalSlots: this.totalCurrentCost.toString(),
        referralCode: this.normalizedReferralCode()
      }
    };

    // Log payment intent values
    console.log('[PAYMENT] Original Currency Type:', this.activity.currencyType);
    console.log('[PAYMENT] Normalized Currency:', normalizedCurrency);
    console.log('[PAYMENT] Payment Intent Data:', paymentIntentData);
    console.log('[PAYMENT] Amount (cents):', paymentIntentData.amount);
    console.log('[PAYMENT] Currency:', paymentIntentData.currency);
    console.log('[PAYMENT] Activity ID:', paymentIntentData.activityId);
    console.log('[PAYMENT] Metadata:', paymentIntentData.metadata);
    
    this.stripeService.createPaymentIntent(paymentIntentData).subscribe({
      next: (response) => {
        console.log('[PAYMENT] Payment intent created:', response);
        this.paymentIntentId = response.paymentIntentId;
        
        // Update elements options with the client secret
        this.elementsOptions = {
          ...this.elementsOptions,
          clientSecret: response.clientSecret
        } as StripeElementsOptions;
      },
      error: (error) => {
        console.error('[PAYMENT] Error creating payment intent:', error);
        this.openSnackBar('Failed to initialize payment. Please try again.', 'Close');
        this.timeToPay = false;
      }
    });
  }

  pay() {
    if (this.paying() || this.paymentElementForm.invalid) {
      if (this.paymentElementForm.invalid) {
        this.openSnackBar('Please fill in all required payment fields', 'Close');
      }
      return;
    }

    if (!this.paymentIntentId || !this.elementsOptions.clientSecret) {
      this.openSnackBar('Payment not initialized. Please try again.', 'Close');
      return;
    }

    this.paying.set(true);

    const {
      name,
      email,
      address,
      zipcode,
      city
    } = this.paymentElementForm.getRawValue();

    this.getElement();

    // Confirm payment using Stripe
    this.stripe
      .confirmPayment({
        elements: this.paymentElement.elements,
        confirmParams: {
          payment_method_data: {
            billing_details: {
              name: name as string,
              email: email as string,
              address: {
                line1: address as string,
                postal_code: zipcode as string,
                city: city as string
              }
            }
          },
          return_url: window.location.origin + '/booking/success'
        },
        redirect: 'if_required'
      })
      .subscribe({
        next: (result) => {
          console.log('[PAYMENT] Payment result:', result);
          this.paying.set(false);
          
          if (result.error) {
            // Show error to customer
            this.openSnackBar(`Payment failed: ${result.error.message}`, 'Close');
            console.error('[PAYMENT] Payment error:', result.error);
          } else {
            // Payment succeeded
            if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
              this.openSnackBar('Payment successful! Processing your booking...', 'Close');
              
              // Create booking record
              this.createBookingAfterPayment(result.paymentIntent.id);
            } else {
              this.openSnackBar('Payment is being processed. Please wait...', 'Close');
            }
          }
        },
        error: (error) => {
          console.error('[PAYMENT] Payment confirmation error:', error);
          this.paying.set(false);
          this.openSnackBar('Payment failed. Please try again.', 'Close');
        }
      });
  }

  /**
   * Create booking record after successful payment
   */
  private createBookingAfterPayment(paymentIntentId: string): void {
    if (!this.dateSelected || !this.availabilityI || !this.activityId) {
      console.error('[BOOKING] Missing required data for booking');
      return;
    }

    // Get customer information from payment form
    const { name, email, phone, referralCode, hotelName, hotelRoomNumber } = this.paymentElementForm.getRawValue();
    const normalizedReferralCode = this.normalizeReferralCode(referralCode);
    const bookingSource = normalizedReferralCode ? 'hotel' : 'direct';

    // Format selected date
    const year = this.dateSelected.getFullYear();
    const month = String(this.dateSelected.getMonth() + 1).padStart(2, '0');
    const day = String(this.dateSelected.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    // Calculate total slots and collect time slot details
    const selectedOptions: number[] = this.bookActivityForm.controls.timeSlotOptions.value || [];
    let totalSlots = 0;
    const selectedTimeSlots: string[] = []; // For modal display
    const selectedTimeSlotsForEmail: string[] = []; // For email (includes slot counts)
    
    selectedOptions.forEach((optionIndex) => {
      let slotsForThisTime = 0;
      let timeSlotLabel = '';
      
      switch (optionIndex) {
        case 0:
          slotsForThisTime = Number(this.bookActivityForm.controls.timeSlots1.value) || 0;
          timeSlotLabel = this.availabilityI?.timeSlots[0]?.timeSlot || '';
          break;
        case 1:
          slotsForThisTime = Number(this.bookActivityForm.controls.timeSlots2.value) || 0;
          timeSlotLabel = this.availabilityI?.timeSlots[1]?.timeSlot || '';
          break;
        case 2:
          slotsForThisTime = Number(this.bookActivityForm.controls.timeSlots3.value) || 0;
          timeSlotLabel = this.availabilityI?.timeSlots[2]?.timeSlot || '';
          break;
      }
      
      if (slotsForThisTime > 0 && timeSlotLabel) {
        totalSlots += slotsForThisTime;
        // Store time slot label for display in modal
        selectedTimeSlots.push(timeSlotLabel);
        // Store with slot count for email
        selectedTimeSlotsForEmail.push(`${timeSlotLabel} (${slotsForThisTime} slots)`);
      }
    });

    if (totalSlots === 0) {
      console.error('[BOOKING] No slots selected');
      this.openSnackBar('No slots selected. Please try again.', 'Close');
      return;
    }

    console.log('[BOOKING] Creating booking with data:', {
      activityId: this.activityId,
      date: formattedDate,
      totalSlots: totalSlots,
      totalCost: this.totalCurrentCost,
      paymentIntentId: paymentIntentId,
      timeSlots: selectedOptions,
      customerName: name,
      customerEmail: email
    });

    // Create booking using Booking model
    const bookingData: Partial<Booking> = {
      activityID: this.activityId,
      date: formattedDate,
      slots: totalSlots,
      total: this.totalCurrentCost, // Use 'total' instead of 'totalCost' to match Booking interface
      activityName: this.activity.name,
      storeName: this.storeName || undefined,
      guestName: name as string,
      guestEmail: email as string,
      guestPhone: (phone as string) || undefined,
      bookingSource,
      referralCode: normalizedReferralCode || undefined,
      hotelName: (hotelName as string) || undefined,
      hotelRoomNumber: (hotelRoomNumber as string) || undefined,
      paymentIntentId,
      // userID will be set if user is logged in, otherwise undefined for guest booking
      userID: undefined // TODO: Get from auth service if user is logged in
    };

    // Store customer info and payment intent ID separately (these are not part of Booking model)
    // They can be stored in Payments table or handled separately
    const customerInfo = {
      customerName: name as string,
      customerEmail: email as string,
      paymentIntentId: paymentIntentId
    };

    // Type assertion needed because service expects GraphQL schema type, but we're using Booking interface
    this.service.createBooking(bookingData as any).subscribe({
      next: (booking) => {
        console.log('[BOOKING] Booking created:', booking);
        console.log('[BOOKING] Booking ID:', booking?.id);
        console.log('[BOOKING] Full booking object:', JSON.stringify(booking, null, 2));
        
        // Validate booking has an ID
        if (!booking || !booking.id) {
          console.error('[BOOKING] Booking created but missing ID:', booking);
          this.openSnackBar('Booking created but missing ID. Please contact support.', 'Close');
          return;
        }

        // Store booking ID and activityId before any potential form reset
        const bookingId = booking.id;
        const currentActivityId = this.activityId;
        
        console.log('[BOOKING] Using booking ID:', bookingId);
        
        // Wrap everything in try-catch to ensure modal always shows
        try {
          // Update availability slots (non-blocking - don't prevent modal/email if this fails)
          this.updateAvailabilitySlots(formattedDate, selectedOptions, currentActivityId)
            .then(() => {
              console.log('[AVAILABILITY] Availability update completed successfully');
            })
            .catch((availabilityError) => {
              console.error('[AVAILABILITY] Error updating availability (non-critical):', availabilityError);
              // Don't prevent modal/email from showing - booking was created successfully
            });
        } catch (availabilityError) {
          console.error('[AVAILABILITY] Error in availability update (non-critical):', availabilityError);
        }

        // Always proceed with email and modal regardless of availability update result
        // Send confirmation email (non-blocking)
        this.sendBookingConfirmationEmail({
          bookingId: bookingId, // Use stored booking ID
          customerEmail: email as string,
          customerName: name as string,
          activityName: this.activity.name,
          date: formattedDate,
          timeSlots: selectedTimeSlotsForEmail, // Use email version with slot counts
          totalSlots: totalSlots,
          totalCost: this.totalCurrentCost,
          currency: this.activity.currencyType || 'USD'
        })
          .then(() => {
            console.log('[EMAIL] Email sent successfully');
          })
          .catch((emailError) => {
            console.error('[EMAIL] Error sending confirmation email (non-critical):', emailError);
            // Don't prevent modal from showing - email failure is non-critical
          })
          .finally(() => {
            // Always show modal - booking was created successfully
            try {
              console.log('[BOOKING] Showing confirmation modal with booking ID:', bookingId);
              this.showBookingConfirmationModal({
                bookingId: bookingId, // Use stored booking ID
                activityName: this.activity.name,
                date: formattedDate,
                timeSlots: selectedTimeSlots,
                totalSlots: totalSlots,
                totalCost: this.totalCurrentCost,
                currency: this.activity.currencyType || 'USD',
                customerName: name as string,
                customerEmail: email as string,
                paymentIntentId: paymentIntentId
              });
            } catch (modalError) {
              console.error('[MODAL] Error showing confirmation modal:', modalError);
              // Even if modal fails, show a snackbar to user
              this.openSnackBar('Booking confirmed! Please check your email for details.', 'Close');
            }
          });
      },
      error: (error) => {
        console.error('[BOOKING] Error creating booking:', error);
        this.openSnackBar('Failed to create booking. Payment was processed. Please contact support.', 'Close');
      }
    });
  }

  /**
   * Update availability slots after booking
   */
  private async updateAvailabilitySlots(date: string, selectedSlotIndices: number[], activityId: string): Promise<void> {
    try {
      console.log(`[AVAILABILITY] Updating slots for date: ${date}, activity: ${activityId}`);
      
      // Get the availability record for this date
      const availabilitiesResponse = await firstValueFrom(this.service.getAvailabilityByDate(date));
      const availabilities = Array.isArray(availabilitiesResponse) ? availabilitiesResponse : [];
      
      console.log(`[AVAILABILITY] Found ${availabilities.length} availability records for date ${date}`);
      console.log(`[AVAILABILITY] Response type:`, typeof availabilitiesResponse, Array.isArray(availabilitiesResponse));
      
      if (!availabilities || availabilities.length === 0) {
        throw new Error(`No availability found for date ${date}`);
      }

      // Log all availabilities for debugging
      console.log('[AVAILABILITY] All availabilities:', availabilities.map(avail => ({
        id: avail?.id || 'MISSING',
        activityID: avail?.activityID || 'MISSING',
        date: avail?.date || 'MISSING'
      })));

      // Find the availability for this activity
      const availability = availabilities.find(avail => avail?.activityID === activityId);
      
      // More explicit null/undefined check
      if (availability === null || availability === undefined) {
        console.error(`[AVAILABILITY] No availability found for activity ${activityId} on date ${date}`);
        console.error(`[AVAILABILITY] Available activity IDs:`, availabilities.map(avail => avail?.activityID || 'MISSING'));
        throw new Error(`No availability found for activity ${activityId} on date ${date}`);
      }

      // Verify availability has an id using optional chaining
      const availabilityId = availability?.id;
      if (!availabilityId) {
        console.error('[AVAILABILITY] Availability object missing id:', JSON.stringify(availability, null, 2));
        throw new Error(`Availability record missing id property for activity ${activityId} on date ${date}`);
      }

      console.log(`[AVAILABILITY] Found availability record with id: ${availabilityId}`);

      // Parse current time slots
      let timeSlots: TimeSlotsI[] = [];
      if (availability.timeSlots) {
        if (typeof availability.timeSlots === 'string') {
          try {
            timeSlots = JSON.parse(availability.timeSlots);
          } catch (parseError) {
            console.error('[AVAILABILITY] Error parsing timeSlots JSON:', parseError);
            throw new Error(`Invalid timeSlots JSON format: ${parseError}`);
          }
        } else {
          timeSlots = availability.timeSlots as TimeSlotsI[];
        }
      }

      console.log(`[AVAILABILITY] Current time slots:`, timeSlots);

      // Update slots for selected time slots
      selectedSlotIndices.forEach((slotIndex) => {
        if (timeSlots[slotIndex]) {
          const slotsToDeduct = slotIndex === 0 
            ? Number(this.bookActivityForm.controls.timeSlots1.value) || 0
            : slotIndex === 1
            ? Number(this.bookActivityForm.controls.timeSlots2.value) || 0
            : Number(this.bookActivityForm.controls.timeSlots3.value) || 0;

          if (slotsToDeduct > 0) {
            const oldSlots = timeSlots[slotIndex].personSlots;
            timeSlots[slotIndex].personSlots = Math.max(0, timeSlots[slotIndex].personSlots - slotsToDeduct);
            console.log(`[AVAILABILITY] Updated slot ${slotIndex}: ${oldSlots} -> ${timeSlots[slotIndex].personSlots} (deducted ${slotsToDeduct})`);
          }
        } else {
          console.warn(`[AVAILABILITY] Time slot index ${slotIndex} not found in availability`);
        }
      });

      // Update availability record
      console.log(`[AVAILABILITY] Updating availability ${availabilityId} with new time slots:`, timeSlots);
      await firstValueFrom(this.service.updateAvailability(availabilityId, {
        timeSlots: JSON.stringify(timeSlots)
      } as any));

      console.log('[AVAILABILITY] Successfully updated availability slots');
      
      // Reload availabilities to refresh the calendar (non-blocking, don't let errors here break the flow)
      try {
        this.loadActivityAvailabilities();
      } catch (reloadError) {
        console.warn('[AVAILABILITY] Error reloading availabilities (non-critical):', reloadError);
        // Don't throw - this is just a refresh operation
      }
    } catch (error) {
      console.error('[AVAILABILITY] Error updating availability slots:', error);
      throw error;
    }
  }

  /**
   * Send booking confirmation email
   */
  private async sendBookingConfirmationEmail(bookingData: {
    bookingId: string;
    customerEmail: string;
    customerName: string;
    activityName: string;
    date: string;
    timeSlots: string[];
    totalSlots: number;
    totalCost: number;
    currency: string;
  }): Promise<void> {
    try {
      console.log('[EMAIL] Sending booking confirmation email:', bookingData);
      
      await firstValueFrom(this.emailService.sendBookingConfirmationEmail(bookingData));
      
      console.log('[EMAIL] Booking confirmation email sent successfully');
    } catch (error) {
      console.error('[EMAIL] Error sending booking confirmation email (non-critical):', error);
      // Don't throw - we still want to show the modal even if email fails
      // Return successfully so the promise chain continues
      return Promise.resolve();
    }
  }

  /**
   * Show booking confirmation modal
   */
  private showBookingConfirmationModal(data: BookingConfirmationData): void {
    const dialogRef = this.dialog.open(BookingConfirmationDialogComponent, {
      width: '600px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      data: data,
      disableClose: false, // Allow closing the modal
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('[BOOKING] Confirmation modal closed - clearing form');
      // Clear form and reset page state after modal is closed
      this.resetBookingForm();
    });
  }

  /**
   * Reset booking form and clear page state
   */
  private resetBookingForm(): void {
    // Reset form controls
    this.bookActivityForm.reset();
    this.paymentElementForm.reset();
    
    // Clear selections
    this.dateSelected = null;
    this.availabilityI = null;
    this.totalCurrentCost = 0;
    this.timeToPay = false;
    this.paymentIntentId = '';
    
    // Reset elements options
    this.elementsOptions = {
      appearance: {
        theme: 'stripe',
      },
      clientSecret: undefined
    } as StripeElementsOptions;
    
    // Reload availabilities to refresh calendar
    this.loadActivityAvailabilities();
    
    console.log('[BOOKING] Form and page state reset');
  }
  constructor(
    private _Activatedroute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private service: ServiceService,
    private stripeService: StripeService,
    private emailService: EmailService
  ) {
    
  }

  private hydrateReferralFromUrl(): void {
    const params = this._Activatedroute.snapshot.queryParams;
    const code = this.normalizeReferralCode(
      params['hotel'] || params['ref'] || params['referral'] || params['referralCode']
    );
    const hotelName = (params['hotelName'] || params['hotel_name'] || '').toString().trim();
    const room = (params['room'] || params['roomNumber'] || '').toString().trim();

    this.paymentElementForm.patchValue({
      referralCode: code,
      hotelName,
      hotelRoomNumber: room,
    });
  }

  private normalizeReferralCode(value: unknown): string {
    return (value || '').toString().trim().toUpperCase();
  }

  normalizedReferralCode(): string {
    return this.normalizeReferralCode(this.paymentElementForm.controls.referralCode.value);
  }

  bookActivityForm = this.formBuilder.group({
    dateSelectionCtrl: ['', Validators.required],
    totalCostCtrl: [0, Validators.required],
    timeSlotOptions: [[]], // Empty array for multiple selections (checkboxes)
    timeSlots1: [{value: 0, disabled: true}, [Validators.min(0)]],
    timeSlots2: [{value: 0, disabled: true}, Validators.min(0)],
    timeSlots3: [{value: 0, disabled: true}, Validators.min(0)],
  })

  modelListUnavailable: Date[] = [];
  unavailables: Date[] = [ ];
  modelListAvailable: Date[] = [];
  availabilitiesLoaded: boolean = false; // Track if availabilities have been loaded
  uDatesStruct: any;
  currentSlotPrice: number;
  currentSlotMax: number;
  signedIn: boolean = false;
  dateSelected: Date | null = null;
  totalCurrentCost: number = 0;
  availabilityI: AvailabilityI | null = null;
  paymentIntentId: string;
  timeToPay: boolean = false;

  ngOnInit() {
    this.activityId = this._Activatedroute.snapshot.params["id"];
    this.hydrateReferralFromUrl();

    if (!this.activityId) {
      console.error('No activity ID provided');
      return;
    }

    // Load activity data, pictures, and store information
    forkJoin({
      activity: this.service.getActivityById(this.activityId),
      pictures: this.service.getPicturesByActivityId(this.activityId)
    }).subscribe({
      next: ({ activity, pictures }) => {
        if (activity) {
          // ALWAYS FORCE discountedPrice to 0 - NO DISCOUNTS UNLESS EXPLICITLY ENABLED
          // This is a temporary fix to ensure no discounts show
          let discountedPrice = 0;
          
          // Log what we received from the database
          console.log(`[DISCOUNT CHECK] Activity "${activity.name}" - Raw discountedPrice from DB:`, activity.discountedPrice, typeof activity.discountedPrice);
          
          // FORCE TO 0 - Comment out the code below if you want to allow discounts
          // Only uncomment and modify if you explicitly want to enable discounts
          
          /*
          // ONLY process if there's a non-null, non-undefined value
          if (activity.discountedPrice != null && activity.discountedPrice !== undefined) {
            // Handle both string and number types
            const rawValue = activity.discountedPrice;
            let priceValue: number;
            
            if (typeof rawValue === 'string') {
              // Skip empty strings or string "0"
              const trimmed = String(rawValue).trim();
              if (trimmed === '' || trimmed === '0') {
                priceValue = 0;
              } else {
                priceValue = parseFloat(trimmed);
              }
            } else {
              priceValue = Number(rawValue);
            }
            
            // ONLY set discount if it's a valid number STRICTLY greater than 1 (percentage)
            // This means discounts must be > 1.0 (e.g., 5%, 10%, etc.)
            if (!isNaN(priceValue) && isFinite(priceValue) && priceValue > 1.0) {
              discountedPrice = priceValue;
              console.log(`[DISCOUNT] Activity "${activity.name}" has valid discount: ${discountedPrice}%`);
            } else {
              // FORCE to 0 if invalid, <= 1, or any other condition
              discountedPrice = 0;
              console.warn(`[DISCOUNT] Activity "${activity.name}" has discountedPrice=${rawValue} (parsed as ${priceValue}) - FORCING to 0`);
            }
          }
          */
          
          // ALWAYS FORCE TO 0
          discountedPrice = 0;
          
          // Log final value for debugging
          console.log(`[DISCOUNT FINAL] Activity "${activity.name}" discountedPrice FORCED to 0 (no discount)`);

          // Map activity data
          this.activity = {
            ...this.defaultActivityValues,
            id: activity.id,
            name: activity.name || '',
            mainActivityType: activity.mainActivityType || '',
            description: activity.description || '',
            fullDescription: activity.fullDescription || '',
            duration: activity.duration || '',
            rating: activity.rating || 0,
            reviews: activity.reviews || 0,
            pricePerPerson: activity.pricePerPerson || 0,
            discountedPrice: discountedPrice,
            currencyType: activity.currencyType || '',
            highlights: activity.highlights ? (typeof activity.highlights === 'string' ? activity.highlights.split(',').map(h => h.trim()) : activity.highlights) : [],
            notSuitable: activity.notSuitable ? (typeof activity.notSuitable === 'string' ? activity.notSuitable.split(',').map(n => n.trim()) : activity.notSuitable) : [],
            storeID: activity.storeID || '',
            startDate: activity.startDate || '',
            endDate: activity.endDate || '',
            sellOut: activity.sellOut || false,
            topPick: activity.topPick || false
          };

          // Set reviews text (only if reviews exist)
          if (this.activity.reviews != null && this.activity.reviews > 0) {
            if (this.activity.reviews != 1) {
              this.reviews = " (" + this.activity.reviews + " reviews)";
            } else {
              this.reviews = " (" + this.activity.reviews + " review)";
            }
          } else {
            this.reviews = ""; // Set to empty string if no reviews
          }

          // Load store information
          if (activity.storeID) {
            this.service.getStoreById(activity.storeID).subscribe({
              next: (store) => {
                if (store) {
                  this.storeName = store.name || '';
                }
              },
              error: (error) => {
                console.error('Error loading store:', error);
              }
            });
          }

          // Log raw pictures data
          console.log(`[PICTURES RAW] Activity "${activity.name}" received ${(pictures || []).length} pictures from DB:`, 
            (pictures || []).map(p => ({ id: p?.id, url: p?.url, description: p?.description }))
          );

          // Check if pictures is null or undefined
          if (!pictures) {
            console.warn(`[NO PICTURES] Pictures response is null/undefined for activity "${activity.name}"`);
            this.pictures = [];
            this.hasValidPictures = false;
          } else {
            // Process pictures asynchronously to get signed URLs
            this.processPicturesAndGetSignedUrls(pictures, activity).catch(error => {
              console.error(`[ERROR] Failed to process pictures:`, error);
              this.pictures = [];
              this.hasValidPictures = false;
            });
          }

          // Calculate current slot price
          const discountAmount = this.activity.discountedPrice > 0 
            ? (this.activity.pricePerPerson * (this.activity.discountedPrice / 100))
            : 0;
          this.currentSlotPrice = this.activity.pricePerPerson - discountAmount;

          // Load all availabilities for this activity to populate unavailable dates
          this.loadActivityAvailabilities();
        } else {
          console.error('Activity not found');
          this.activity = this.defaultActivityValues;
          this.pictures = [];
          this.hasValidPictures = false;
        }
      },
      error: (error) => {
        console.error(`[ERROR] Failed to load activity or pictures for activity ID "${this.activityId}":`, error);
        this.pictures = [];
        this.hasValidPictures = false;
        this.activity = this.defaultActivityValues;
      }
    });

    // TODO: Implement user authentication check
    this.signedIn = false;
  }

  /**
   * Load all availabilities for this activity to determine unavailable dates
   */
  loadActivityAvailabilities(): void {
    if (!this.activityId) {
      return;
    }

    this.service.getAvailabilityByActivityId(this.activityId).subscribe({
      next: (availabilities) => {
        console.log(`[AVAILABILITY] Loaded ${availabilities.length} availability records for activity ${this.activityId}`);
        
        // Store available dates for reference
        const availableDates: Date[] = [];
        
        // Convert availability dates to Date objects
        availabilities.forEach((avail) => {
          if (avail.date) {
            try {
              // Parse date string (format: YYYY-MM-DD)
              const dateParts = avail.date.split('-');
              if (dateParts.length === 3) {
                const year = parseInt(dateParts[0], 10);
                const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed
                const day = parseInt(dateParts[2], 10);
                const date = new Date(year, month, day);
                
                // Check if date is valid and has time slots
                if (!isNaN(date.getTime()) && avail.timeSlots) {
                  try {
                    const timeSlots = typeof avail.timeSlots === 'string' 
                      ? JSON.parse(avail.timeSlots)
                      : avail.timeSlots;
                    
                    // Only mark as available if it has valid time slots
                    if (Array.isArray(timeSlots) && timeSlots.length > 0) {
                      availableDates.push(date);
                    }
                  } catch (e) {
                    console.warn(`[AVAILABILITY] Invalid timeSlots for date ${avail.date}:`, e);
                  }
                }
              }
            } catch (error) {
              console.warn(`[AVAILABILITY] Error parsing date ${avail.date}:`, error);
            }
          }
        });
        
        console.log(`[AVAILABILITY] Found ${availableDates.length} dates with availability`);
        
        // Mark that availabilities have been loaded
        this.availabilitiesLoaded = true;
        
        // Store available dates - these are the ONLY dates that should be selectable
        this.modelListAvailable = availableDates;
        
        // Clear unavailable list as we're using the whitelist approach (only available dates are selectable)
        this.modelListUnavailable = [];
      },
      error: (error) => {
        console.error(`[AVAILABILITY] Error loading availabilities:`, error);
        // Mark as loaded even on error so we don't show all dates
        this.availabilitiesLoaded = true;
        // If we can't load availabilities, don't allow any dates (empty list)
        this.modelListAvailable = [];
        this.modelListUnavailable = [];
      }
    });
  }

  /**
   * Process pictures array, filter duplicates, and get signed URLs from Amplify Storage
   */
  private async processPicturesAndGetSignedUrls(pictures: any[], activity: any): Promise<void> {
    try {
      // Filter out invalid pictures first
      const validPictures = pictures.filter(pic => {
        if (!pic || !pic.url) {
          console.warn(`[INVALID] Skipping invalid picture:`, pic);
          return false;
        }
        const trimmedUrl = pic.url.trim();
        if (trimmedUrl === '') {
          console.warn(`[EMPTY] Skipping picture with empty URL:`, pic);
          return false;
        }
        return true;
      });

      // Remove duplicates
      const seenUrls = new Set<string>();
      const seenIds = new Set<string>();
      
      const uniquePictures = validPictures
        .filter((pic, index) => {
          // Check for duplicate by ID first
          if (pic.id && seenIds.has(pic.id)) {
            console.warn(`[DUPLICATE ID] Skipping picture with duplicate ID: ${pic.id}, URL: ${pic.url}`);
            return false;
          }
          
          // Check for duplicate by URL (normalized)
          const normalizedUrl = pic.url.trim().toLowerCase();
          if (seenUrls.has(normalizedUrl)) {
            console.warn(`[DUPLICATE URL] Skipping picture with duplicate URL: ${pic.url} (ID: ${pic.id})`);
            return false;
          }
          
          // Add to seen sets
          if (pic.id) seenIds.add(pic.id);
          seenUrls.add(normalizedUrl);
          
          // Add unique track identifier for template tracking
          (pic as any)._uniqueTrack = pic.id || `${activity.id}-pic-${index}-${normalizedUrl.substring(0, 15)}`;
          
          return true;
        })
        .slice(0, 4); // Only take first 4 unique pictures

      // Get signed URLs for each picture
      const picturePromises = uniquePictures.map(async (pic, index) => {
        let signedUrl = pic.url;
        
        // If URL doesn't start with http/https, it's likely a storage key
        if (!pic.url.startsWith('http://') && !pic.url.startsWith('https://')) {
          try {
            // Try to get signed URL from Amplify Storage
            const urlResult = await getUrl({
              key: pic.url,
              options: {
                accessLevel: 'guest'
              }
            });
            signedUrl = urlResult.url.toString();
            console.log(`[SIGNED URL] Got signed URL for picture ${index}: ${signedUrl}`);
          } catch (urlError) {
            console.warn(`[URL ERROR] Failed to get signed URL for key "${pic.url}":`, urlError);
            signedUrl = pic.url;
          }
        } else {
          // Already a full URL, try to refresh if it's an S3 URL that might need signing
          const urlStr = pic.url;
          if (urlStr.includes('amazonaws.com') || urlStr.includes('s3')) {
            try {
              // Extract key from URL
              const keyMatch = urlStr.match(/activity-images\/[^?]+/);
              if (keyMatch) {
                const key = keyMatch[0];
                const urlResult = await getUrl({
                  key: key,
                  options: {
                    accessLevel: 'guest'
                  }
                });
                signedUrl = urlResult.url.toString();
                console.log(`[SIGNED URL] Refreshed signed URL for S3 URL: ${signedUrl}`);
              }
            } catch (urlError) {
              console.warn(`[URL ERROR] Failed to refresh signed URL, using original:`, urlError);
              signedUrl = pic.url;
            }
          }
        }
        
        return {
          ...pic,
          url: signedUrl,
          originalUrl: pic.url
        };
      });
      
      // Wait for all signed URLs
      const picturesWithUrls = await Promise.all(picturePromises);
      this.pictures = picturesWithUrls;
      
      // Log final unique pictures
      console.log(`[PICTURES FINAL] Activity "${activity.name}" has ${this.pictures.length} unique pictures:`, 
        this.pictures.map((p, index) => ({ 
          index, 
          url: p.url, 
          id: p.id,
          urlNormalized: p.url?.trim().toLowerCase()
        }))
      );
      
      // Check if we have valid pictures
      this.hasValidPictures = this.pictures.length > 0 && this.pictures.some(p => p && p.url && p.url.trim() !== '');
      
      console.log(`[PICTURES STATUS] Activity "${activity.name}" - Pictures array length: ${this.pictures.length}, hasValidPictures: ${this.hasValidPictures}`);
      
      if (this.hasValidPictures) {
        console.log(`[VALID PICTURES] Found ${this.pictures.length} valid pictures with URLs:`, 
          this.pictures.map(p => p.url)
        );
      } else {
        console.warn(`[NO VALID PICTURES] Activity "${activity.name}" has ${this.pictures.length} pictures but none have valid URLs - showing banner`);
      }
    } catch (error) {
      console.error(`[ERROR] Failed to process pictures:`, error);
      this.pictures = [];
      this.hasValidPictures = false;
      throw error;
    }
  }

  handleImageError(event: any, pic: any, index: number): void {
    const imgElement = event.target as HTMLImageElement;
    const imageUrl = pic?.url || imgElement.src;
    
    console.error(`[IMAGE ERROR] Failed to load image for activity "${this.activity?.name || 'Unknown'}" at index ${index}:`, {
      imageUrl: imageUrl,
      pictureId: pic?.id,
      activityId: this.activity?.id,
      error: event,
      element: imgElement
    });
    
    // Hide the failed image
    if (imgElement) {
      imgElement.style.display = 'none';
      
      // Remove the failed picture from array and check if we need to show banner
      if (pic && this.pictures) {
        const picIndex = this.pictures.indexOf(pic);
        if (picIndex > -1) {
          this.pictures.splice(picIndex, 1);
        }
        
        // Check if all valid pictures are now gone
        this.hasValidPictures = this.pictures.some(p => p && p.url && p.url.trim() !== '');
        if (!this.hasValidPictures) {
          this.pictures = [];
        }
      }
    }
  }

  openImageCarousel(initialIndex: number): void {
    if (!this.pictures || this.pictures.length === 0) {
      return;
    }

    const dialogRef = this.dialog.open(ImageCarouselDialogComponent, {
      width: '90vw',
      maxWidth: '1200px',
      height: '90vh',
      maxHeight: '800px',
      panelClass: 'image-carousel-dialog',
      data: {
        pictures: this.pictures,
        initialIndex: initialIndex,
        activityName: this.activity?.name || 'Activity'
      } as ImageCarouselDialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Image carousel dialog closed');
    });
  }

  dateSelection() {
    if (!this.dateSelected || !this.activityId) {
      console.warn('[DATE SELECTION] No date or activity ID selected');
      this.availabilityI = null;
      return;
    }

    // Format date as YYYY-MM-DD
    const year = this.dateSelected.getFullYear();
    const month = String(this.dateSelected.getMonth() + 1).padStart(2, '0');
    const day = String(this.dateSelected.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    console.log(`[DATE SELECTION] Loading availability for date: ${formattedDate}, activity: ${this.activityId}`);

    // Load availability for the selected date and activity
    this.service.getAvailabilityByDate(formattedDate).subscribe({
      next: (availabilities) => {
        // Filter availabilities for this activity
        const activityAvailability = availabilities.find(avail => avail.activityID === this.activityId);
        
        if (activityAvailability && activityAvailability.timeSlots) {
          try {
            // Parse the JSON string of time slots
            const timeSlotsArray = typeof activityAvailability.timeSlots === 'string' 
              ? JSON.parse(activityAvailability.timeSlots)
              : activityAvailability.timeSlots;

            // Map to TimeSlotsI format
            const newTimeslots: TimeSlotsI[] = Array.isArray(timeSlotsArray)
              ? timeSlotsArray.map((slot: any) => ({
                  timeSlot: slot.timeSlot || slot.timeSlots || '',
                  personSlots: slot.personSlots || slot.personSlots || 0
                }))
              : [];

            if (newTimeslots.length > 0) {
              this.availabilityI = {
                availabilityDate: formattedDate,
                timeSlots: newTimeslots
              };
              console.log(`[DATE SELECTION] Loaded ${newTimeslots.length} time slots for ${formattedDate}:`, this.availabilityI);
            } else {
              console.warn(`[DATE SELECTION] No time slots found for date ${formattedDate}`);
              this.availabilityI = null;
            }
          } catch (error) {
            console.error(`[DATE SELECTION] Error parsing time slots JSON:`, error);
            this.availabilityI = null;
          }
        } else {
          console.warn(`[DATE SELECTION] No availability found for date ${formattedDate} and activity ${this.activityId}`);
          this.availabilityI = null;
        }
      },
      error: (error) => {
        console.error(`[DATE SELECTION] Error loading availability:`, error);
        this.availabilityI = null;
      }
    });
  }

  timePicker() {
    const selectedOptions: number[] = this.bookActivityForm.controls.timeSlotOptions.value || [];
    
    console.log(`[TIME PICKER] Selected time slot options:`, selectedOptions);
    
    // Get all available time slot form controls
    const timeSlotControls = [
      this.bookActivityForm.controls.timeSlots1,
      this.bookActivityForm.controls.timeSlots2,
      this.bookActivityForm.controls.timeSlots3
    ];
    
    // Enable/disable and reset time slot inputs based on selection
    timeSlotControls.forEach((control, index) => {
      if (selectedOptions.includes(index)) {
        // Enable the control if this time slot is selected
        control.enable();
      } else {
        // Disable and reset to 0 if this time slot is not selected
        control.disable();
        control.setValue(0);
      }
    });
    
    // Reset total cost if no time slots are selected
    if (selectedOptions.length === 0) {
      this.bookActivityForm.controls.totalCostCtrl.setValue(0);
      this.totalCurrentCost = 0;
    } else {
      // Recalculate total cost with current values
      this.takeSlot();
    }
  }
  takeSlot() {
    const selectedOptions: number[] = this.bookActivityForm.controls.timeSlotOptions.value || [];
    
    if (selectedOptions.length === 0) {
      this.totalCurrentCost = 0;
      this.bookActivityForm.controls.totalCostCtrl.setValue(0);
      return;
    }
    
    // Sum up slots from all selected time slots
    let totalSlotsUsing = 0;
    
    selectedOptions.forEach((optionIndex) => {
      let slotsForThisTime = 0;
      
      switch (optionIndex) {
        case 0:
          slotsForThisTime = Number(this.bookActivityForm.controls.timeSlots1.value) || 0;
          break;
        case 1:
          slotsForThisTime = Number(this.bookActivityForm.controls.timeSlots2.value) || 0;
          break;
        case 2:
          slotsForThisTime = Number(this.bookActivityForm.controls.timeSlots3.value) || 0;
          break;
        default:
          break;
      }
      
      totalSlotsUsing += slotsForThisTime;
    });
    
    // Calculate total cost based on all selected time slots
    this.totalCurrentCost = this.currentSlotPrice * totalSlotsUsing;
    this.bookActivityForm.controls.totalCostCtrl.setValue(this.totalCurrentCost);
    
    console.log(`[TAKE SLOT] Total slots: ${totalSlotsUsing}, Total cost: ${this.totalCurrentCost}`);
  }
  unavailableFilter = (date: Date | null): boolean => {
    // If no date provided, disable it
    if (!date) {
      return false;
    }

    // Disable past dates (including dates before today)
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const checkDate = new Date(date);
    checkDate.setHours(0, 0, 0, 0);
    
    if (checkDate < today) {
      return false; // Past dates are not selectable
    }

    // IMPORTANT: Only allow dates if availabilities have been loaded
    // This prevents showing dates as selectable before we know if they're available
    if (!this.availabilitiesLoaded) {
      // While loading, disable all dates (including today) to prevent false positives
      return false;
    }

    // If availabilities have been loaded, ONLY allow dates that are in modelListAvailable
    if (this.modelListAvailable && this.modelListAvailable.length > 0) {
      const hasAvailability = this.modelListAvailable.some((adate: Date) => {
        const availableDate = new Date(adate);
        availableDate.setHours(0, 0, 0, 0);
        return availableDate.getFullYear() === checkDate.getFullYear() &&
               availableDate.getMonth() === checkDate.getMonth() &&
               availableDate.getDate() === checkDate.getDate();
      });

      // Return true if date has availability (selectable), false otherwise (greyed out)
      return hasAvailability;
    } else {
      // If availabilities loaded but no available dates, disable all dates (including today)
      return false;
    }
  }
  bookActivity() {
    // TODO: Implement payment confirmation with Amplify Gen 2
    // const paymentElement = this.elements._elements.getElement("payment");

    // console.log("paymentElement", paymentElement);
    // this.getElement();
    // this.restAPI
    // .confirmPaymentIntent({ piid: this.paymentIntentId, payment_method: paymentElement })
    // .subscribe((pi) => {
    //   this.elementsOptions.clientSecret = pi.client_secret as string;
    //   this.paymentIntentId = pi.id;
    //   console.log('payment intent info', pi);
    //   console.log('client secret', this.elementsOptions.clientSecret);
    // });

    // let booking: CreateBookingInput = {
    //   date: this.bookActivityForm.controls.dateSelectionCtrl.value,
    //   slots: Number(this.bookActivityForm.controls.slotsSelectorCtrl.value),
    //   priceperslot: this.activity.pricePerPerson,
    //   bookingUsersId: this.userId,
    //   bookingStoreId: this.activity.storeID,
    //   bookingActivityId: this.activity.id
    // }

    // let convertToDate: Date = new Date(this.bookActivityForm.controls.dateSelectionCtrl.value);

    // this.modelListUnavailable.push(convertToDate);

    // this.AWSAPI.CreateBooking(booking).then((result) => {

    //   this.modelListUnavailable.sort((a, b) => b.getDate() - a.getDate());

    //   let unavailableDate: UpdateUnavailableDatesInput = {
    //     id: this.uDatesStruct.id,
    //     dates: JSON.stringify(this.modelListUnavailable),
    //     //activityID: this.activity.id
    //   }

    //   this.AWSAPI.UpdateUnavailableDates(unavailableDate);

    //   let updateActivity: UpdateActivityInput = {
    //     id: this.activity.id,
    //     //slots: Number(this.bookActivityForm.controls.slotsTotalLeftCtrl.value)
    //   }
    //   this.AWSAPI.UpdateActivity(updateActivity).then(() => {
    //     this.bookActivityForm.reset();
    //     this.openSnackBar("Activity " + this.activity.name, "Close");
    //   });

    // }).catch((reason) => {
    //   console.log("reason", reason);
    // })
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }
  openDialog(): void {
    // @media (min-width:320px)  { /* smartphones, iPhone, portrait 480x320 phones */ }
    // @media (min-width:481px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ }
    // @media (min-width:641px)  { /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */ }
    // @media (min-width:961px)  { /* tablet, landscape iPad, lo-res laptops ands desktops */ }
    // @media (min-width:1025px) { /* big landscape tablets, laptops, and desktops */ }
    // @media (min-width:1281px) { /* hi-res laptops and desktops */ }

    let largeScreen = {
      height: '1000px',
      width: '1000px'
    }

    let screenWidth: string;
    let screenHeight: string;

    if (window.matchMedia("(min-width: 1281px)")) {
      screenWidth = largeScreen.width;
      screenHeight = largeScreen.height;
    }

    const dialogRef = this.dialog.open(CheckAvailability, {
      data: { activity: this.activity},
      height: screenHeight,
      width: screenWidth
    });
  }
}

// Image Carousel Dialog Component
@Component({
  selector: 'app-image-carousel-dialog',
  template: `
    <div class="image-carousel-dialog-container">
      <div class="carousel-header">
        <h2 mat-dialog-title>{{data.activityName}} - Gallery</h2>
        <button mat-icon-button (click)="dialogRef.close()" class="close-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div mat-dialog-content class="carousel-content">
        @if (data.pictures && data.pictures.length > 0) {
          <ngb-carousel [activeId]="'slide-' + data.initialIndex" class="modal-carousel">
            @for (pic of data.pictures; track pic._uniqueTrack || pic.id || ($index + '-' + pic.url) || $index) {
              @if (pic && pic.url && pic.url.trim() !== '') {
                <ng-template ngbSlide [id]="'slide-' + $index">
                  <div class="carousel-image-container">
                    <img class="carousel-modal-image" [src]="pic.url" [alt]="pic.description || data.activityName" (error)="handleImageError($event)">
                    @if (pic.description) {
                      <div class="image-description">{{pic.description}}</div>
                    }
                  </div>
                </ng-template>
              }
            }
          </ngb-carousel>
        }
      </div>
    </div>
  `,
  styles: [`
    .image-carousel-dialog-container {
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #000;
    }
    
    .carousel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 24px;
      background: rgba(0, 0, 0, 0.9);
      color: white;
      
      h2 {
        margin: 0;
        font-size: 1.5rem;
        font-weight: 600;
        color: white;
      }
      
      .close-button {
        color: white;
      }
    }
    
    .carousel-content {
      flex: 1;
      padding: 0;
      margin: 0;
      overflow: hidden;
      
      ::ng-deep .modal-carousel {
        height: 100%;
        
        .carousel-inner {
          height: 100%;
        }
        
        .carousel-item {
          height: 100%;
          transition: transform 0.6s ease-in-out;
        }
      }
    }
    
    .carousel-image-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      background: #000;
    }
    
    .carousel-modal-image {
      max-width: 100%;
      max-height: calc(90vh - 120px);
      width: auto;
      height: auto;
      object-fit: contain;
      border-radius: 8px;
    }
    
    .image-description {
      color: white;
      text-align: center;
      padding: 16px;
      font-size: 1rem;
      max-width: 800px;
      margin-top: 16px;
    }
    
    ::ng-deep .image-carousel-dialog {
      .mat-mdc-dialog-container {
        padding: 0;
        border-radius: 8px;
        overflow: hidden;
      }
    }
  `],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule, NgbModule]
})
export class ImageCarouselDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImageCarouselDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImageCarouselDialogData
  ) {}

  handleImageError(event: any): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.style.display = 'none';
    console.error('Failed to load image in carousel:', event);
  }
}

@Component({
    selector: 'check-availability',
    templateUrl: './check-availability.html',
    styleUrls: ['./check-availability.scss'],
    standalone: true,
    imports: [CommonModule, MatDialogModule, BookingDialogComponent]
})
export class CheckAvailability {
  constructor(
    public dialogRef: MatDialogRef<CheckAvailability>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}



  onNoClick(): void {
    this.dialogRef.close();
  }



}

